// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"langMenu-module--menu-container--3yySB","langLink":"langMenu-module--lang-link--1NtDO","langLinkActive":"langMenu-module--lang-link-active--EzoaQ"};